import api, { transformRequest, transformResponse } from "services/api";

export const debtorAssetCategoriesApi = api
  .enhanceEndpoints({ addTagTypes: ["DebtorAssetCategory"] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchDebtorAssetCategories: build.query({
        query: (payload = {}) => ({
          url: `/api/v1/core/debtor-asset-categories/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? [
                ...results.map(({ id }) => ({ type: "DebtorAssetCategory", id })),
                { type: "DebtorAssetCategory", id: "LIST" },
              ]
            : [{ type: "DebtorAssetCategory", id: "LIST" }],
      }),
      addDebtorAssetCategory: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-asset-categories/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorAssetCategory", id: "LIST" }],
      }),
      updateDebtorAssetCategory: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-asset-categories/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorAssetCategory", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchDebtorAssetCategoriesQuery,
  useAddDebtorAssetCategoryMutation,
  useUpdateDebtorAssetCategoryMutation,
} = debtorAssetCategoriesApi;
